const actions = {
  LISTEN: "LISTEN",
  SET_GAP: "SET_GAP"
};

export default actions;